// extracted by mini-css-extract-plugin
module.exports = {"container":"__404_container__MNLb7","errorHeader":"__404_errorHeader__fO0WK"};